import { useContext, useMemo } from 'react';
import { AppContext } from 'context';
export const useUrl = (routeName, params, query)=>{
    const { getUrl } = useContext(AppContext);
    return useMemo(()=>getUrl(routeName, params, query), [
        routeName,
        params,
        query
    ]);
};
